module.exports = __webpack_public_path__ + "static/media/TUSD.b92cebdb.svg";